
import React from 'react';
import { MdOutlineDelete, MdPersonOutline } from 'react-icons/md';
import './TagList.css';
import { DynamicIcon } from '../DynamicIcon/DynamicIcon';

function TagList({ tags, onRemove, disabled }) {
	if (!tags || tags.length === 0) {
		return (
			<div className="tags-list-container">
				<p className="empty-text">Nenhuma etiqueta selecionada.</p>
			</div>
		);
	}

	return (
		<div className="tags-list-container">
			{tags.map((tag, idx) => (
				<div className="item-row tag-container" key={idx} style={{ '--tagColor': tag.color }}>
					<span className='tag-info-container'>
						<span className='tag-texts'>
							{tag.icon ? (
								<DynamicIcon iconName={tag.icon} color={tag.color} size={17} />
							) : (
								<span></span>
							)}
							<span>{tag.name}</span>
						</span>
						{!disabled && (
							<button type="button" className="btn-delete-item" onClick={() => onRemove(idx)}>
								<MdOutlineDelete size={18} />
							</button>
						)}
					</span>
				</div>
			))}
		</div>
	);
}

export default TagList;
